module.exports = __webpack_public_path__ + "static/media/about_photo.9df6e446.jpg";